import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Dispatch, bindActionCreators } from 'redux';
import { getGroupContent } from 'Pages/InfoGroupBookingPage/Redux/selectors';
import { fetchGroupContent } from 'Pages/InfoGroupBookingPage/Redux/thunks';
import { getIsFetching } from 'Pages/InfoGroupBookingPage/Redux/selectors';
import InfoGroupBookingPage from './InfoGroupBookingsPage';

interface IPropsInternal {
  isFetching: boolean;
  content: Julius.Website.GroupPageViewModel;
  fetchGroupContent: () => void;
}

type Props = IPropsInternal;

class InfoGroupBookingPageContainer extends React.PureComponent<Props> {

  componentDidMount() {
    this.props.fetchGroupContent();
  }

  render() {
    return (
      <InfoGroupBookingPage 
        isFetching={ this.props.isFetching }
        content={ this.props.content } 
      />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    isFetching: getIsFetching(state),
    content: getGroupContent(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchGroupContent,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(InfoGroupBookingPageContainer);


// WEBPACK FOOTER //
// ./src/pages/InfoGroupBookingPage/InfoGroupBookingPageContainer.tsx